import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { Placement } from "react-bootstrap/esm/types";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { ButtonWithIcon } from "../button-with-icon/button-with-icon";

type CopyToClipboardWrapperProps = {
    id?: string;
    label?: string;
    disabled?: boolean;
    title: string;
    text?: string;
    variant?: string;
    icon?: IconDefinition;
    className?: string;
    placement: Placement;
};

export const CopyToClipboardWrapper = (props: CopyToClipboardWrapperProps) => {
    const {
        id,
        label,
        text,
        title,
        disabled,
        variant,
        icon,
        className,
        placement
    } = props;

    const renderTooltip = (props: any) => (
        <Tooltip id="copied-tooltip" {...props}>
            Copied!
        </Tooltip>
    );

    const onClickCopy = () => {
        if (navigator?.clipboard?.writeText) {
            navigator.clipboard.writeText(text);
        }
    };

    return (
        <OverlayTrigger trigger={"click"} placement={placement} overlay={renderTooltip} rootClose={true}>
            <ButtonWithIcon
                id={id}
                title={title}
                variant={variant}
                disabled={disabled}
                className={className}
                icon={icon}
                text={label}
                onClick={onClickCopy}
            />
        </OverlayTrigger>
    );
};